import { render, staticRenderFns } from "./DepartList2.vue?vue&type=template&id=f89f1952&scoped=true"
import script from "./DepartList2.vue?vue&type=script&lang=js"
export * from "./DepartList2.vue?vue&type=script&lang=js"
import style0 from "./DepartList2.vue?vue&type=style&index=0&id=f89f1952&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89f1952",
  null
  
)

export default component.exports